export const iconBoxStyle = {
  width: 20,
  minWidth: 20,
  maxWidth: 20,
  height: 20,
  minHeight: 20,
  maxHeight: 20,
};
